import { Badge, FlexBox, Icon, Tooltip } from '@dixa/lib-shared-habla';

import { PredictedConversationQualityScore } from '../messageSection/utils';

type ConversationQualityScoreProps = {
  score?: PredictedConversationQualityScore;
};
export function ConversationQualityScore(
  props: ConversationQualityScoreProps,
): JSX.Element | null {
  if (!props.score) return null;

  const { qualityScore, qualityScoreTrend, variant } = props.score;

  if (qualityScore === null) return <></>;

  const comparisonIcon =
    qualityScoreTrend !== 'neutral' ? (
      <Icon
        name={qualityScoreTrend === 'decreasing' ? 'trend-down' : 'trend-up'}
      />
    ) : null;

  const badgeVariant = variant === 'positive' ? 'success' : 'error';
  return (
    <Tooltip content="Conversation quality score" wrap="span">
      <Badge size="small" variant={badgeVariant}>
        <FlexBox gap="100" alignItems="center" justifyContent="center">
          {qualityScore}% {comparisonIcon}
        </FlexBox>
      </Badge>
    </Tooltip>
  );
}
